import React from 'react';
import { safeMutate } from '../../../../utils/GeneralUtils';
import PieChart from '../../Reports/templates/PieChart';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getChartConfig, { chartOnlyMetrics } from './utils';
import { isPresent } from '../../../../utils/CoreExtensions/ArrayExtensions';
import useChartReflow from '../../../../hooks/generic/charts/useChartReflow';
import { exportEventName } from '.';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import ChrLink from '../../../generic/Utils/ChrLink';
import i18n from '../../../../utils/ChrI18n';

const Body = (props) => {
  const { metrics, name } = props;
  const numericMetrics = metrics.filter(metric => !chartOnlyMetrics.includes(metric.uId));
  const inactiveGroups = getMetricDataFromArray(metrics, MetricUId.INACTIVE_GROUPS_COUNT);
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();
  const propsForNumericMetrics = safeMutate(props, draftProps => {
    draftProps.metrics = numericMetrics;
  });

  return (
    <WidgetBodyWrapper { ...props } additionalClassNames="custom-max-height-550-px" >
      <div className="d-flex flex-column">
        <div ref={ chartWrapperReference }>
          <div className={ "col-12 col-md-6 mx-auto" }>
            <PieChart
              chartOptions={ getChartConfig({ metrics, name }) }
              configs={ { export: true, exportEventName } }
              callbackFn={ chartCallbackFunction }
            />
          </div>
        </div>
        { isPresent(numericMetrics) &&
          <div className="cui-border-gray border-radius-0-5-important mb-3">
            <WidgetBodyWrapper { ...propsForNumericMetrics }  />
          </div>
        }
        { inactiveGroups.inactivitySetting &&
          <div className='cui-widget-info-bg d-flex flex-gap-10 p-3 border-radius-0-25 font-bold '>
            <i className="fa-regular fa-gear mt-1" />
            <span>{ inactiveGroups.inactivitySetting.infoText }</span>
            <ChrLink newTab href={ inactiveGroups.inactivitySetting.url }>({ i18n.t("display_string.Change") })</ChrLink>
          </div>
        }
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;
